/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */

import './CheckInView.scss'
import React from 'react'
import { ListGroup } from '../../molecules'
import r from '../../../util/Renderer'
import { ArrowRight, DatePicker, Dropdown, ListItem, OtaLogo, SearchField } from '../../atoms'
import { dateToStringDate } from '../../../util/DateString'
import LocalArea from '../../templates/LocalArea'
import Cell from '../../templates/Cell'
import CheckInAction from '../../../action/check_in'
import ReceptionistAction from '../../../action/reservation'
import CheckInSearchAction from '../../../action/check_in/index'
import { CarefulButton, NavigationDrawer, NormalButton, Pagination } from 'ui-library/dist/external/components'

function CheckInView(props) {
  const reservations = props.reservations ? props.reservations : []
  const search_keywords = props.search.search_keywords || null
  const search_room_ids = props.search.search_room_ids || []
  const search_room_options = props.search.search_room_options || []
  const search_check_in = props.search.search_check_in || null
  const loading_room_option = props.search.loading_room_option || null
  const toolbar = { label: '宿泊台帳管理', items: props.accountMenu }

  const pagination = props.pagination
  const searchFunction = params => {
    const pagination = props.pagination.merge({ page: params.page, per_page: params.perPage })
    CheckInSearchAction.onSearch(props.search, pagination)
  }

  return (
    <div id="CheckInManagement">
      <NavigationDrawer toolbar={toolbar} navigations={props.navigations} />

      <LocalArea>
        <SearchField className="searchKeyword" placeholder="名前、メール、電話番号、予約番号" name="search_keywords" value={search_keywords} onChange={e => CheckInAction.onEditSearchCondition(e)} />
        <Dropdown
          raised
          className="searchHouse"
          name="search_room_ids"
          value={search_room_ids}
          options={search_room_options}
          isLoading={loading_room_option}
          isClearable={true}
          isMulti={true}
          searchable={true}
          onChange={e => CheckInAction.onEditSearchCondition(e)}
        />

        <DatePicker
          className="searchCheckIn"
          name="search_check_in"
          selected={search_check_in}
          value={search_check_in}
          onChange={e => CheckInAction.onEditSearchCondition(e)}
          showTimeSelect={false}
          isClearable={true}
          placeholderText="チェックイン日"
        />

        <NormalButton type="dark" size="lg" onClick={e => searchFunction(pagination)}>
          検索
        </NormalButton>
      </LocalArea>

      <div className="Reservations">
        <div className="Reservations__List">
          {r.renderIfOrElse(reservations.size > 0)(
            <ListGroup border="underline" className="ItemGroup">
              {reservations.map(reservation => (
                <ListItem key={reservation.id} className="Item">
                  <Cell className="Item__Name">{reservation.name}</Cell>
                  <Cell className="Item__Hotel">{reservation.stay}</Cell>
                  <Cell className="Item__Period">
                    <p>
                      <span className="checkin">{dateToStringDate(reservation.check_in)}</span>
                      <span className="arrow">
                        &nbsp;
                        <ArrowRight />
                        &nbsp;
                      </span>
                      <span className="checkout">{dateToStringDate(reservation.check_out)}</span>
                    </p>
                    <p>
                      <span className="arrival">{reservation.guest_arrival_time}</span>
                    </p>
                  </Cell>
                  <Cell className="Item__Referer">
                    <OtaLogo value={reservation.site_referer} />
                  </Cell>
                  <Cell className="Item__Action">
                    {r.renderIf(r)(<NormalButton onClick={e => ReceptionistAction.toCheckInView(e, reservation.id)}>編集</NormalButton>)}

                    <CarefulButton onClick={() => onConfirm(reservation)}>削除</CarefulButton>
                  </Cell>
                </ListItem>
              ))}
            </ListGroup>
          )(
            <div className="row">
              <div className="col-12">
                <div className="Reservations__List--empty">
                  <div className="inner">
                    <div className="message">登録されている宿泊台帳はありません</div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <Pagination
        name="pagination"
        perPage={pagination.per_page}
        total={pagination.total}
        page={pagination.page}
        prev={e => searchFunction(e.value)}
        next={e => searchFunction(e.value)}
        perPageChanged={e => searchFunction(e.value)}
      />
    </div>
  )
}

function onConfirm(reservation) {
  if (window.confirm('削除しますがよろしいですか？')) {
    CheckInAction.onRequestDelete(reservation.id)
  }
}

export default CheckInView
